import * as yup from 'yup';

export const EmployeeNoPersonValidationSchema = yup.object().shape({
    FirstName: yup.string().required('First name is required'),
    LastName: yup.string().required('Last name is required'),
    Gender: yup.number().required('Gender is required').typeError('Gender is required'),
    RaceId: yup.number().required('Race is required').typeError('Race is required'),
    OccupationLevelTypeId: yup.number().typeError("Occupational Level is required").required("Occupational Level is required"),
    EmployeeTypeId: yup.number().typeError("Employment Type is required").required("Employment Type is required"),
    Province: yup.number().typeError("Province is required").required("Province is required").default(0),
    IdentificationNumber: yup.string().when('EmployeeCode', {
        is: (EmployeeCode: string) => !EmployeeCode || EmployeeCode.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }),
    EmployeeCode: yup.string().when('IdentificationNumber', {
        is: (IdentificationNumber: string) => !IdentificationNumber || IdentificationNumber.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }),
}, [[ 'EmployeeCode', 'IdentificationNumber' ]]
);

export const EmployeePersonValidationSchema = yup.object().shape({
    FirstName: yup.string().required('First name is required'),
    LastName: yup.string().required('Last name is required'),
    Gender: yup.number().required('Gender is required').typeError('Gender is required'),
    RaceId: yup.number().required('Race is required').typeError('Race is required'),
    Province: yup.number().typeError("Province is required").required("Province is required").default(0),
    IdentificationNumber: yup.string().when('EmployeeCode', {
        is: (EmployeeCode: string) => !EmployeeCode || EmployeeCode.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }),
    EmployeeCode: yup.string().when('IdentificationNumber', {
        is: (IdentificationNumber: string) => !IdentificationNumber || IdentificationNumber.length === 0,
        then: yup.string().required("ID Number or Employee Code is required"),
        otherwise: yup.string().nullable()
    }),
}, [[ 'EmployeeCode', 'IdentificationNumber' ]]
);